import React from 'react'

import './primary-button.css'

const PrimaryButton = (props) => {
  return <div className="primary-button-container"></div>
}

export default PrimaryButton
